var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.confirmPaymentComp)?_c(_vm.confirmPaymentComp,{tag:"component",staticClass:"confirm-payment"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }